import React from 'react'
import clsx from 'clsx'
import { NoteFavorite } from 'iconsax-react'
import { useTheme } from '@mui/material'
import { useDrag, useDrop } from 'react-dnd'

import DragIcon from '@SonarCX/components/icons/DragIcon'
import OverflowText from '@SonarCX/components/atoms/OverflowText'

import useStyles from './styles'

const ITEM_TYPE = 'NOTE'

type NoteProps = {
  note: APIAgentNote
  onClick: () => void
  onMove: (start: string, end: string, isAbove: boolean) => void
  isFirst: boolean
  isLast: boolean
}

const Note: React.FC<NoteProps> = ({
  note,
  onClick,
  onMove,
  isFirst,
  isLast
}) => {
  const theme = useTheme()

  const [{ opacity }, dragRef, previewRef] = useDrag({
    item: { type: ITEM_TYPE, id: note.id },
    collect: monitor => ({
      opacity: monitor.isDragging() ? 0.8 : 1,
      dragging: !!monitor.isDragging()
    })
  })

  const [{ isOver: isOverTop }, dropTop] = useDrop({
    accept: ITEM_TYPE,
    drop: (item: any) => onMove(item.id, note.id, true),
    collect: monitor => ({
      isOver: !!monitor.isOver()
    })
  })

  const [{ isOver: isOverBottom }, dropBottom] = useDrop({
    accept: ITEM_TYPE,
    drop: (item: any) => onMove(item.id, note.id, false),
    collect: monitor => ({
      isOver: !!monitor.isOver()
    })
  })

  const classes = useStyles()

  return (
    <div className={classes.root}>
      {isFirst && (
        <div
          ref={dropTop}
          className={clsx(
            classes.drop,
            classes.dropTop,
            isOverTop && classes.dropOver
          )}
        />
      )}

      <div
        ref={previewRef}
        onClick={onClick}
        className={classes.row}
        style={{ opacity }}
      >
        <div ref={dragRef} className={classes.drag}>
          <DragIcon style={{ paddingTop: 4 }} />
        </div>

        <OverflowText className={classes.title}>{note.title}</OverflowText>

        <NoteFavorite size={theme.size.xl} color={theme.palette.primary.main} />
      </div>

      <div
        ref={dropBottom}
        className={clsx(
          classes.drop,
          classes.dropBottom,
          isLast && classes.dropBottomRound,
          isOverBottom && classes.dropOver
        )}
      />
    </div>
  )
}

export default Note
